import { injectReducer } from '../../store/reducers';
import { injectSagas } from '../../store/sagas';

export default store => ({
  path: '/conferences/:id/apply/payment/cash',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      const Counter = require('./containers/ConferenceApplyCashContainer').default;
      const reducer = require('reducers/conferences').default;
      const sagas = require('sagas/sagas').default;

      injectReducer(store, { key: 'conferences', reducer });
      injectSagas(store, { key: 'sagas', sagas });

      cb(null, Counter);
    }, 'ConferenceApplyTransfer');
  },
});



// WEBPACK FOOTER //
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/routes/ConferenceApplyCash/index.js